export default __webpack_public_path__ + "static/media/masterrock-035-rockwool-platte_comp.9c253b81.jpg";